import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateM3uFile from '../../components/M3u/EditCreateM3uFile'
import { useGetM3uFilesQuery, useLazyGetM3uFilesQuery } from '../../redux/apis/linkManagement/m3u/lmM3uFilesApiSlice'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const M3uFiles = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetM3uFilesQuery({
    expand: ['last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize
  })

  const [create, setCreate] = useState(false)

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'FILE PATH',
      dataIndex: 'file_path',
      key: 'file_path',
      search: true
    },
    {
      title: 'FILE TYPE',
      dataIndex: 'file_type',
      key: 'file_type',
      search: true
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          {text.first_name} {text.last_name}
        </div>
      )
    },
    {
      title: 'CREATED AT',
      dataIndex: 'created_at',
      key: 'created_at'
    }
  ]

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  // show toast errors
  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(msg => toast.error(msg))
    }
  }, [error])

  // adjust layout on mount/unmount
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_m3ufiles') && create && (
        <EditCreateM3uFile
          state='create'
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      <div className='ml-auto flex gap-4'>
        <DownloadAllDataButton
          lazyQueryHook={useLazyGetM3uFilesQuery}
          fileName='m3ufiles'
        />
        {can('add_m3ufiles') && (
          <button
            className='btn btn-outline-theme ml-auto'
            onClick={() => setCreate(true)}
          >
            Create New M3U File
          </button>
        )}
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default M3uFiles
